import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import FilledButton from '../FilledButton';
import Svg from '../Svg';
import { pantryDetailsPromptStyleSheet } from '../profile/pantryDetailsPromptStyleSheet';
import { useLocalization } from '../../store/utils/useLocalization';

import { AppText } from '../AppText';

function AdditionalInfoRequired(props) {
  const { showModal } = props;
  const { t } = useLocalization();
  const programName = t('additional_details');

  return (
    <View style={pantryDetailsPromptStyleSheet.view}>
      <View style={pantryDetailsPromptStyleSheet.container}>
        <View style={pantryDetailsPromptStyleSheet.leftContainer}>
          <Svg
            icon="unverified"
            color={pantryDetailsPromptStyleSheet.icon.color}
            width={pantryDetailsPromptStyleSheet.icon.width}
            height={pantryDetailsPromptStyleSheet.icon.height}
          />
          <View style={pantryDetailsPromptStyleSheet.promptContainer}>
            <AppText style={pantryDetailsPromptStyleSheet.text}>
              {t('pantry_details_prompt_title', {
                programName,
              })}
            </AppText>
            <View style={pantryDetailsPromptStyleSheet.promptLabelContainer}>
              <AppText style={pantryDetailsPromptStyleSheet.promptLabel}>
                {t('pantry_details_prompt_visit_label', { programName })}
              </AppText>
            </View>
          </View>
        </View>
        <View style={pantryDetailsPromptStyleSheet.buttonContainer}>
          <FilledButton
            label={t('program_complete_now')}
            full={false}
            color={pantryDetailsPromptStyleSheet.button.color}
            onPress={showModal}
            paddingHorizontal={pantryDetailsPromptStyleSheet.button.paddingHorizontal}
          />
        </View>
      </View>
    </View>
  );
}

AdditionalInfoRequired.propTypes = {
  showModal: PropTypes.func.isRequired,
};

export default AdditionalInfoRequired;
